import React, { useCallback } from 'react';
import { MBView } from '@shared/components/MBView';
import { MBBottomSheet, MBBottomSheetTitleBar } from '@shared/components/bottomSheet';
import { FIXED_WIDTH } from '@shared/components/multiSelect';
import { grid } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import { SelectSubform } from './SelectSubform';

interface Props {
  blockLabel: string;
  anchorName: string;
  workflowTemplate?: MBAPI.WorkflowTemplate;
  onClose: VoidFunction;
  onSelect: (subformWorkflowTemplate: MBAPI.WorkflowTemplate) => void;
  navigateToAdd?: () => void;
}

export function SubformsSheet({
  blockLabel,
  anchorName,
  workflowTemplate,
  onClose,
  onSelect,
  navigateToAdd,
}: Props) {
  const isDesktop = useIsDesktop();
  const fixedWidth = isDesktop ? FIXED_WIDTH : null;

  const renderTitleBar = useCallback(() => {
    return <MBBottomSheetTitleBar title={blockLabel} rightIcon="exit" onRightIconPress={onClose} />;
  }, [onClose, blockLabel]);

  return (
    <MBBottomSheet
      anchorName={anchorName}
      style={{
        minWidth: fixedWidth?.width,
        minHeight: grid(36),
      }}
      onClose={onClose}
      renderTitleBar={!isDesktop ? renderTitleBar : undefined}
    >
      <MBView style={fixedWidth} fill>
        <SelectSubform
          workflowTemplate={workflowTemplate}
          onSelect={onSelect}
          navigateToAdd={navigateToAdd}
        />
      </MBView>
    </MBBottomSheet>
  );
}
